import { call, options, params } from './helpers';

export const addCategory = (payload) =>
	call(`/beta/category`, options(payload, 'POST'));

export const deleteCategory = (payload) =>
	call(`/beta/category`, options(payload, 'DELETE'));

export const addCategoryField = ({ id, ...payload }) =>
	call(`/beta/category/${id}/addField`, options(payload, 'PUT'));

export const removeCategoryField = ({ id, ...payload }) =>
	call(`/beta/category/${id}/removeField`, options(payload, 'PUT'));
